/**
 * Tiny CSV export helpers shared across feature folders.
 *
 * No CSV library — hand-rolled escape + Blob download. Pulling in PapaParse
 * for a handful of call sites isn't worth the bytes.
 */

/** Format a numeric percentile to 2dp, blank if null/undefined/NaN. */
export function csvNum(v: number | null | undefined, digits = 2): string {
  return v == null || !Number.isFinite(v) ? '' : v.toFixed(digits);
}

/**
 * Trigger a browser download of an arbitrary Blob.
 *
 * The single place in the app that pokes the DOM to start a download — every
 * CSV / PDF / file export funnels through here, so the throwaway `<a>` lives
 * in exactly one spot rather than being copy-pasted per feature.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** Trigger a browser download of a CSV string. */
export function downloadCsv(content: string, filename: string): void {
  downloadBlob(new Blob([content], { type: 'text/csv;charset=utf-8;' }), filename);
}
